export const sortItemsByDateWithDateKey = (items, dateKey) => {
    return [...items].sort((a, b) => {
      const dateA = new Date(a[dateKey]);
      const dateB = new Date(b[dateKey]);
      return dateB - dateA;
    });
  };